<template>
  <div class="flex column" v-title data-title="意见反馈">
    <div style="padding-top: 20px">
      <div v-for="(item, index) in list" :key="index">
        <div class="flex column" style="margin-left: 28px">
          <div class="flex">
            <div style="font-size: 15px; color: #030303FF; font-weight: bolder">{{index + 1}}.&nbsp;</div>
            <div class="flex column">
              <div style="font-size: 15px; color: #030303FF; font-weight: bold">{{item.title}}</div>
              <div style="font-size: 14px; color: #878787FF;">联系：{{item.name}}</div>
              <div style="font-size: 14px; color: #878787FF">微信：{{item.wx}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as Utils from './../utils/utils'

  export default {
    name: "Feedback",
    data() {
      return {
        list: []
      }
    },
    created() {
      var type = Utils.getUrlParam('type')
      if (type === 'teacher') {
        this.list = [
          {title: '教师问题（教师认证、赠书申请等）', name: '斯琪老师', wx: 'yuebanjun07'},
          {title: '学校问题（添加或修改学校）', name: '斯琪老师', wx: 'yuebanjun07'},
          {title: '阅伴App使用问题', name: '春风老师', wx: 'yuebanyezi'},
          {title: '阅伴共读活动问题', name: '春风老师', wx: 'yuebanyezi'},
          {title: '图书商城问题（售前售后咨询、阅芽兑换等）', name: '阿伟老师', wx: 'yueban04'}
        ]
      } else if (type === 'student') {
        this.list = [
          {title: '闯关问题（书目、题目有误）', name: '包包老师', wx: 'yuebanjiaoyukf'},
          {title: '学校问题（添加或修改学校）', name: '斯琪老师', wx: 'yuebanjun07'},
          {title: '阅伴App使用问题', name: '春风老师', wx: 'yueban0609'},
          {title: '阅伴共读活动问题', name: '春风老师', wx: 'yueban0609'},
          {title: '图书商城问题（售前售后咨询、阅芽兑换等）', name: '阿伟老师', wx: 'yueban04'},
          {title: '阅伴课程咨询（直播课、录播课等）', name: '小茜老师', wx: 'yueban2020'}
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Feedback.vue